






















import { Component, Vue } from 'vue-property-decorator';
import Slider from './components/Slider.vue';
import Header from './components/Header.vue';
import TestResults from './components/TestResults.vue';
import InfoSection from './components/InfoSection.vue';
import BackSection from './components/BackSection.vue';
import Footer from './components/Footer.vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './scss/main.scss';

@Component({
  components: {
    Slider,
    Header,
    TestResults,
    InfoSection,
    BackSection,
    Footer
  },
})
export default class App extends Vue {

  data(){
    return {
      ...this.$store.state.customer
    }
  }

  onClick2(){
  }  
}

